export var SALUTATIONS = {
  MR: __('Mr'),
  MRS: __('Mrs'),
  MISS: __('Miss'),
  DR: __('Dr'),
  MS: __('Ms'),
  COMMERCIAL: __('Commercial'),
  JOINT: __('Joint'),
  REVEREND: __('Reverend')
};
export var SUFFIXES = {
  JR: __('JR'),
  SR: __('SR'),
  I: __('I'),
  II: __('II'),
  III: __('III'),
  IV: __('IV'),
  V: __('V')
};
export var LANGUAGE = {
  ENGLISH: __('English'),
  FRENCH: __('French'),
  SPANISH: __('Spanish'),
  FRENCH_CANADA: __('French Canada'),
  OTHER: __('Other')
};
export var DURATION_PERIOD = {
  MONTH: 'MONTH',
  YEAR: 'YEAR'
};
export var DURATION_TYPES = {
  MONTH: __('mo'),
  YEAR: __('yr')
};
export var GROSS_INCOME_INTERVALS = {
  WEEKLY: __('Weekly'),
  BI_WEEKLY: __('Bi-Weekly'),
  MONTHLY: __('Monthly'),
  YEARLY: __('Yearly')
};
export var EMPLOYMENT_TYPES = {
  PROFESSIONAL: __('Professional'),
  EXECUTIVE: __('Executive/Managerial'),
  CLERICAL: __('Clerical'),
  SKILLED_LABOR: __('Skilled Labor '),
  SEMI_SKILLED_LABOR: __('Semi-Skilled Labor'),
  CRAFTSMAN: __('Craftsman'),
  SALES_OR_ADVERTISING: __('Sales/Advertising'),
  GOVERNMENT: __('Government'),
  AUTO_WORKER: __('Auto Worker '),
  FARMER: __('Farmer'),
  FISHER_MAN: __('Fisherman'),
  HOME_MAKER: __('Homemaker'),
  OTHER: __('Other')
};